/*=========================================================================================
  File Name: moduleDashboardMutations.js
  Description: Dashboard Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import i18n from "@/i18n/i18n.js"

export default {

    SET_DOWNLOAD_COUNT(state, data) {
        state.countOfTotalChannel = data.countOfTotalChannel
        state.countOfActiveChannel = data.countOfActiveChannel
        state.countOfErrorChannel = data.countOfErrorChannel
        state.countOfTotalDashcam = data.countOfTotalDashcam
        state.countOfActivatedDashcam = data.countOfActivatedDashcam
        state.countOfTotalUser = data.countOfTotalUser
        state.countOfSubscriptionYUser = data.countOfSubscriptionYUser
    },

    SET_DAILY_WOWZA_REPORT(state, data) {
        let thisMonth = data.thisMonthByDaily
        let previousMonth = data.previousMonthByDaily

        let series = [{
            name: i18n.t('THIS_MONTH'),
            data: [thisMonth.day01, thisMonth.day02, thisMonth.day03, thisMonth.day04, thisMonth.day05, thisMonth.day06, thisMonth.day07, thisMonth.day08, thisMonth.day09, thisMonth.day10,
                thisMonth.day11, thisMonth.day12, thisMonth.day13, thisMonth.day14, thisMonth.day15, thisMonth.day16, thisMonth.day17, thisMonth.day18, thisMonth.day19, thisMonth.day20,
                thisMonth.day21, thisMonth.day22, thisMonth.day23, thisMonth.day24, thisMonth.day25, thisMonth.day26, thisMonth.day27, thisMonth.day28, thisMonth.day29, thisMonth.day30,
                thisMonth.day31
            ]
        }, {
            name: i18n.t('LAST_MONTH'),
            data: [previousMonth.day01, previousMonth.day02, previousMonth.day03, previousMonth.day04, previousMonth.day05, previousMonth.day06, previousMonth.day07, previousMonth.day08, previousMonth.day09, previousMonth.day10,
                previousMonth.day11, previousMonth.day12, previousMonth.day13, previousMonth.day14, previousMonth.day15, previousMonth.day16, previousMonth.day17, previousMonth.day18, previousMonth.day19, previousMonth.day20,
                previousMonth.day21, previousMonth.day22, previousMonth.day23, previousMonth.day24, previousMonth.day25, previousMonth.day26, previousMonth.day27, previousMonth.day28, previousMonth.day29, previousMonth.day30,
                previousMonth.day31
            ]
        }]

        state.wowzaDailyReportSeries = series
        state.sumOfThisMonthWowzaTotalUsage = data.sumOfThisMonth
        state.sumOfPreviousMonthWowzaTotalUsage = data.sumOfPreviousMonth
    },
}